import { useState, type FormEvent } from 'react';
import { motion } from 'framer-motion';
import { Send } from 'lucide-react';
import type { ContactFormConfig } from '../data/profile';

type ContactFormProps = {
  form: ContactFormConfig;
};

export function ContactForm({ form }: ContactFormProps) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const message = [
      form.messageIntro,
      '',
      `Nome: ${name.trim()}`,
      `Telefone: ${phone.trim()}`
    ].join('\n');

    window.open(`${form.whatsappBaseUrl}?text=${encodeURIComponent(message)}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <motion.form
      className="contact-form"
      onSubmit={handleSubmit}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.36, delay: 0.1, ease: 'easeOut' }}
    >
      <h2>{form.title}</h2>

      <label className="form-field">
        <span>{form.nameLabel}</span>
        <input
          type="text"
          name="name"
          value={name}
          onChange={(event) => setName(event.target.value)}
          placeholder={form.namePlaceholder}
          autoComplete="name"
          required
        />
      </label>

      <label className="form-field">
        <span>{form.phoneLabel}</span>
        <input
          type="tel"
          name="phone"
          value={phone}
          onChange={(event) => setPhone(event.target.value)}
          placeholder={form.phonePlaceholder}
          autoComplete="tel"
          inputMode="tel"
          required
        />
      </label>

      <label className="terms-control">
        <input
          type="checkbox"
          checked={acceptedTerms}
          onChange={(event) => setAcceptedTerms(event.target.checked)}
          required
        />
        <span>{form.terms}</span>
      </label>

      <button className="form-submit" type="submit" disabled={!acceptedTerms}>
        <span>{form.submitLabel}</span>
        <Send size={16} strokeWidth={1.9} />
      </button>
    </motion.form>
  );
}
